import { FsPickemDetails, FsPickemDetailsBase } from "../FsPickemDetails";
import { FsMatchemPointsRules } from "./FsMatchemPointsRules";

export type FsMatchemDetails = FsPickemDetailsBase & {
  pointsRules: FsMatchemPointsRules | undefined;
  subSegmentNum: number | undefined;
};

export const isFsMatchemDetails = (
  pickemDetails: FsPickemDetails
): pickemDetails is FsMatchemDetails => {
  return pickemDetails.pickemType === "Matchem";
};
